<template>
  <div class="promote-share">
    <div class="qr-section">
      <div class="qr-left" @click="saveQrCode">
        <div class="qr-placeholder">
          <img :src="qrCodeUrl" class="qr-img" v-if="qrCodeUrl" />
          <van-icon name="qr" size="60" color="#DFB372" v-else />
        </div>
        <div class="qr-tip">保存邀请码</div>
      </div>
      <div class="qr-right">
        <div class="share-link">
          <select class="link-select" v-model="selectedDomain" @change="updateShareLink">
            <option v-for="domain in domainList" :key="domain" :value="domain">{{ domain }}/#/?pid={{ userInfo.id }}</option>
          </select>
          <svg class="link-copy" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="copyLink">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </div>
        <div class="share-buttons">
          <div class="share-item" @click="handleShare()">
            <div class="share-icon-share">
              <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
              </svg>
            </div>
            <span class="share-text">分享</span>
          </div>
          <div class="share-item" @click="shareToPlatform('wechat')">
            <img src="/static/image/promote/home/img_wx.png" class="share-icon-img" />
            <span class="share-text">Wechat</span>
          </div>
          <div class="share-item" @click="shareToPlatform('qq')">
            <img src="/static/image/promote/home/img_qq.png" class="share-icon-img" />
            <span class="share-text">QQ</span>
          </div>
          <div class="share-item" @click="shareToPlatform('moments')">
            <img src="/static/image/promote/home/img_pyq.png" class="share-icon-img" />
            <span class="share-text">WeChat</span>
            <span class="share-text" style="margin-top:0;">Moments</span>
          </div>
          <div class="share-item" @click="shareToPlatform('facebook')">
            <img src="/static/image/promote/home/img_facebook.png" class="share-icon-img" />
            <span class="share-text">Facebook</span>
          </div>
          <div class="share-item" @click="shareToPlatform('telegram')">
            <img src="/static/image/promote/home/img_tg.png" class="share-icon-img" />
            <span class="share-text">Telegram</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tutorial-card">
      <div class="card-title">代理教程</div>
      <div class="tutorial-tabs">
        <div class="tutorial-tab" :class="{ active: activeTab === 0 }" @click="activeTab = 0">A的佣金</div>
        <div class="tutorial-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">B1的佣金</div>
        <div class="tutorial-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">B2的佣金</div>
      </div>
      <div class="tutorial-content">
        <div v-if="activeTab === 0" class="tutorial-panel">
          <div class="a-commission-diagram">
            <svg class="connect-lines" viewBox="0 0 375 480" preserveAspectRatio="none">
              <!-- A -> B1/B2 -->
              <path d="M187 80 L187 105" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M187 105 L100 105" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M187 105 L275 105" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M100 105 L100 135" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M275 105 L275 135" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="100,143 94,131 106,131" fill="#DFB372"/>
              <polygon points="275,143 269,131 281,131" fill="#DFB372"/>

              <!-- B1 -> C1/C2 -->
              <path d="M100 180 L100 210" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M100 210 L79 210" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M100 210 L203 210" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M79 210 L79 245" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M203 210 L203 245" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="79,253 73,241 85,241" fill="#DFB372"/>
              <polygon points="203,253 197,241 209,241" fill="#DFB372"/>

              <!-- B2 -> C3 -->
              <path d="M275 180 L275 210" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M275 210 L327 210" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M327 210 L327 245" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="327,253 321,241 333,241" fill="#DFB372"/>

              <!-- C -> N -->
              <path d="M79 285 L79 325" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M203 285 L203 325" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M327 285 L327 325" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M79 325 L187 325" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M203 325 L187 325" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M327 325 L187 325" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M187 325 L187 365" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="187,373 181,361 193,361" fill="#DFB372"/>
            </svg>

            <!-- A级代理 -->
            <div class="agent-card agent-a">
              <div class="agent-left">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_a.avif" class="agent-avatar" alt="A" />
                  <span class="agent-badge badge-a">A</span>
                </div>
              </div>
              <div class="agent-right">
                <div class="calc-line"><span class="calc-label">直属业绩</span>=500+3000=<span class="calc-gold">3500</span></div>
                <div class="calc-line"><span class="calc-label">直属佣金</span>=3500*10%=<span class="calc-gold">350</span></div>
                <div class="calc-line"><span class="calc-label">其他佣金</span>=30+60+600=<span class="calc-gold">690</span></div>
                <div class="calc-line"><span class="calc-label">本期佣金</span>=350+690=<span class="calc-gold">1040</span></div>
              </div>
            </div>

            <!-- B级 -->
            <div class="b-level-row">
              <div class="agent-card agent-b">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_b.avif" class="agent-avatar" alt="B1" />
                  <span class="agent-badge badge-b">B1</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 500</div>
                  <div class="agent-calc">给A佣金500*10%=<span class="calc-gold">50</span></div>
                </div>
              </div>
              <div class="agent-card agent-b">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_b.avif" class="agent-avatar" alt="B2" />
                  <span class="agent-badge badge-b">B2</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 3000</div>
                  <div class="agent-calc">给A佣金3000*10%=<span class="calc-gold">300</span></div>
                </div>
              </div>
            </div>

            <!-- C级 -->
            <div class="c-level-row">
              <div class="agent-card agent-c">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_c.avif" class="agent-avatar" alt="C1" />
                  <span class="agent-badge badge-c">C1</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 1000</div>
                  <div class="agent-calc">给A佣金</div>
                  <div class="agent-calc">1000*10%*30%=<span class="calc-gold">30</span></div>
                </div>
              </div>
              <div class="agent-card agent-c">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_c.avif" class="agent-avatar" alt="C2" />
                  <span class="agent-badge badge-c">C2</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 2000</div>
                  <div class="agent-calc">给A佣金</div>
                  <div class="agent-calc">2000*10%*30%=<span class="calc-gold">60</span></div>
                </div>
              </div>
              <div class="agent-card agent-c">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_c.avif" class="agent-avatar" alt="C3" />
                  <span class="agent-badge badge-c">C3</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 20000</div>
                  <div class="agent-calc">给A佣金</div>
                  <div class="agent-calc">20000*10%*30%=<span class="calc-gold">600</span></div>
                </div>
              </div>
            </div>

            <!-- N级 -->
            <div class="agent-card agent-nd">
              <div class="agent-avatar-wrap">
                <img src="/static/image/promote/home/img_tg_tx_nd.avif" class="agent-avatar" alt="N" />
                <span class="agent-badge badge-n">N</span>
              </div>
              <div class="agent-body">
                <div class="agent-bet">(无数下级)</div>
                <div class="agent-calc">每一级都可给A贡献业绩和佣金，且不限下级层数，越多越好</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 1" class="tutorial-panel">
          <div class="a-commission-diagram">
            <svg class="connect-lines" viewBox="0 0 375 400" preserveAspectRatio="none">
              <!-- B1 -> C1/C2 -->
              <path d="M187 80 L187 105" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M187 105 L100 105" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M187 105 L275 105" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M100 105 L100 135" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M275 105 L275 135" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="100,143 94,131 106,131" fill="#DFB372"/>
              <polygon points="275,143 269,131 281,131" fill="#DFB372"/>

              <!-- C1/C2 -> N -->
              <path d="M100 235 L100 275" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M275 235 L275 275" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M100 275 L187 275" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M275 275 L187 275" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <path d="M187 275 L187 305" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="187,313 181,301 193,301" fill="#DFB372"/>
            </svg>

            <!-- B1级代理 -->
            <div class="agent-card agent-a">
              <div class="agent-left">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_b.avif" class="agent-avatar" alt="B1" />
                  <span class="agent-badge badge-a">B1</span>
                </div>
              </div>
              <div class="agent-right">
                <div class="calc-line"><span class="calc-label">直属业绩</span>=1000+2000=<span class="calc-gold">3000</span></div>
                <div class="calc-line"><span class="calc-label">直属佣金</span>=3000*10%=<span class="calc-gold">300</span></div>
                <div class="calc-line"><span class="calc-label">其他佣金</span>=0</div>
                <div class="calc-line"><span class="calc-label">本期佣金</span>=300+0=<span class="calc-gold">300</span></div>
              </div>
            </div>

            <!-- C级 -->
            <div class="c-level-row">
              <div class="agent-card agent-c">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_c.avif" class="agent-avatar" alt="C1" />
                  <span class="agent-badge badge-c">C1</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 1000</div>
                  <div class="agent-calc">给B1佣金1000*10%=<span class="calc-gold">100</span></div>
                </div>
              </div>
              <div class="agent-card agent-c">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_c.avif" class="agent-avatar" alt="C2" />
                  <span class="agent-badge badge-c">C2</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 2000</div>
                  <div class="agent-calc">给B1佣金2000*10%=<span class="calc-gold">200</span></div>
                </div>
              </div>
            </div>

            <!-- N级 -->
            <div class="agent-card agent-nd">
              <div class="agent-avatar-wrap">
                <img src="/static/image/promote/home/img_tg_tx_nd.avif" class="agent-avatar" alt="N" />
                <span class="agent-badge badge-n">N</span>
              </div>
              <div class="agent-body">
                <div class="agent-bet">(无数下级)</div>
                <div class="agent-calc">每一级都可给B1贡献业绩和佣金，且不限下级层数，越多越好</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 2" class="tutorial-panel">
          <div class="a-commission-diagram">
            <svg class="connect-lines" viewBox="0 0 375 400" preserveAspectRatio="none">
              <!-- B2 -> C3 -->
              <path d="M187 80 L187 130" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="187,138 181,126 193,126" fill="#DFB372"/>

              <!-- C3 -> N -->
              <path d="M187 235 L187 285" stroke="#DFB372" stroke-width="2.5" fill="none"/>
              <polygon points="187,293 181,281 193,281" fill="#DFB372"/>
            </svg>

            <!-- B2级代理 -->
            <div class="agent-card agent-a">
              <div class="agent-left">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_b.avif" class="agent-avatar" alt="B2" />
                  <span class="agent-badge badge-a">B2</span>
                </div>
              </div>
              <div class="agent-right">
                <div class="calc-line"><span class="calc-label">直属业绩</span>=20000=<span class="calc-gold">20000</span></div>
                <div class="calc-line"><span class="calc-label">直属佣金</span>=20000*10%=<span class="calc-gold">2000</span></div>
                <div class="calc-line"><span class="calc-label">其他佣金</span>=0</div>
                <div class="calc-line"><span class="calc-label">本期佣金</span>=2000+0=<span class="calc-gold">2000</span></div>
              </div>
            </div>

            <!-- C级 -->
            <div class="c-level-row single">
              <div class="agent-card agent-c">
                <div class="agent-avatar-wrap">
                  <img src="/static/image/promote/home/img_tg_tx_c.avif" class="agent-avatar" alt="C3" />
                  <span class="agent-badge badge-c">C3</span>
                </div>
                <div class="agent-body">
                  <div class="agent-bet">有效投注 20000</div>
                  <div class="agent-calc">给B2佣金20000*10%=<span class="calc-gold">2000</span></div>
                </div>
              </div>
            </div>

            <!-- N级 -->
            <div class="agent-card agent-nd">
              <div class="agent-avatar-wrap">
                <img src="/static/image/promote/home/img_tg_tx_nd.avif" class="agent-avatar" alt="N" />
                <span class="agent-badge badge-n">N</span>
              </div>
              <div class="agent-body">
                <div class="agent-bet">(无数下级)</div>
                <div class="agent-calc">每一级都可给B2贡献业绩和佣金，且不限下级层数，越多越好</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-note-card">
      <div class="note-title">
        <van-icon name="info-o" color="#DFB372" size="16" />
        <span>佣金层级说明</span>
      </div>
      <div class="note-content">
        <p>举例说明如下：</p>
        <p>假设当前有效投注的返佣比例为10%（即来自直属下级），跨级部分额外佣金为比例中的比例（站长额外赠送），赠送比例为30%，A是第一个发现商机的，马上发展了B1和B2；B1又往下发展了C1和C2；B2往下发展了C3，第二天B1的有效投注为500，B2的有效投注为3000，C1的有效投注为1000，C2的有效投注为2000，C3的有效投注为20000。</p>
        <p>那么他们之间的收益计算方式如下：</p>
        <p>1、B2的收益计算方式如下：</p>
        <p>（1）B2说明：B2的佣金来源于其直属下级C3贡献；</p>
        <p>（2）B2的直属业绩：即B2的直属下级C3给B2贡献的业绩，计算公式为：直属业绩=C3有效投注=20000；</p>
        <p>（3）B2的直属佣金：直属佣金=直属业绩*返佣比例=20000*10%=2000；</p>
        <p>（4）B2的其他佣金：因C3没有发展下级，故B2没有其他佣金；即其他佣金=0；</p>
        <p>（5）B2的本期佣金：本期佣金=直属佣金+其他佣金=2000+0=2000。</p>
        <p>2、全民代理补充说明：</p>
        <p>因全民代理代理模式可以发展无限下级，即N代表无限级，即可横向发展同时也可以纵向发展；为了便于解说，本文只取2层结构作为例子阐述。</p>
      </div>
    </div>

    <div class="bottom-space"></div>
  </div>
</template>

<script>
export default {
  name: 'promoteShare',
  data() {
    return {
      activeTab: 0,
      userInfo: {},
      shareLink: '',
      qrCodeUrl: '',
      domainList: [],
      selectedDomain: '',
    };
  },
  created() {
    this.getUserInfo();
    this.initDomainList();
  },
  methods: {
    initDomainList() {
      let registerDomain = this.$store.state.appInfo.register_domain || '';
      if (registerDomain) {
        this.domainList = registerDomain.split(',').map(d => d.trim()).filter(d => d);
        if (this.domainList.length > 0) {
          this.selectedDomain = this.domainList[0];
          this.updateShareLink();
        }
      }
    },
    updateShareLink() {
      if (this.selectedDomain && this.userInfo.id) {
        let domain = this.selectedDomain;
        if (!domain.startsWith('http')) {
          domain = 'http://' + domain;
        }
        this.shareLink = domain + '/#/?pid=' + this.userInfo.id;
        this.qrCodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + encodeURIComponent(this.shareLink);
      }
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          that.userInfo = res.data;
          that.updateShareLink();
        }
      });
    },
    copyLink() {
      this.copyToClipboard(this.shareLink, '链接复制成功');
    },
    copyToClipboard(text, msg) {
      const done = () => this.$notify({ type: 'success', message: msg });
      const fail = () => this.$notify({ type: 'danger', message: '复制失败，请长按手动复制' });
      // 优先 execCommand（APP WebView 兼容性最好，clipboard API 在非 https 环境常被拒）
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      ta.setSelectionRange(0, String(text).length); // iOS WebView 必须
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      if (ok) {
        done();
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(fail);
      } else {
        fail();
      }
    },
    saveQrCode() {
      if (!this.qrCodeUrl) {
        this.$notify({ type: 'danger', message: '邀请码尚未生成' });
        return;
      }
      // PC浏览器直接打开图片，手机端长按可保存；与首页保持一致即可
      const link = document.createElement('a');
      link.href = this.qrCodeUrl;
      link.download = 'invite_' + (this.userInfo.id || 'code') + '.png';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$notify({ type: 'success', message: '邀请码图片已打开，长按可保存到相册' });
    },
    handleShare() {
      if (navigator.share) {
        navigator.share({
          title: '邀请注册',
          text: '邀请您注册，一起赚钱！',
          url: this.shareLink,
        });
      } else {
        this.copyLink();
      }
    },
    shareToPlatform(type) {
      const shareUrl = encodeURIComponent(this.shareLink);
      const shareText = encodeURIComponent('邀请您注册，一起赚钱！');

      switch (type) {
        case 'wechat':
          const wechatUrl = `weixin://dl/business/?ticket=${encodeURIComponent(this.shareLink)}`;
          window.open(wechatUrl);
          break;
        case 'qq':
          const qqUrl = `mqq://shareui/openshare?url=${shareUrl}&title=${shareText}`;
          window.open(qqUrl);
          break;
        case 'moments':
          const momentsUrl = `weixin://dl/moments?url=${shareUrl}`;
          window.open(momentsUrl);
          break;
        case 'facebook':
          const fbUrl = `fb://share?href=${shareUrl}`;
          window.open(fbUrl);
          break;
        case 'telegram':
          const tgUrl = `tg://msg_url?url=${shareUrl}&text=${shareText}`;
          window.open(tgUrl);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.promote-share {
  min-height: 100vh;
  background: #292A2C;
  padding: 0.2rem;
  box-sizing: border-box;
}

.qr-section {
  background: #333436;
  border-radius: 0.16rem;
  padding: 0.2rem;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 0.24rem;

  .qr-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
    border-radius: 0.1rem;
    padding: 0.15rem;
    margin: .2rem;

    .qr-placeholder {
      width: 1.5rem;
      height: 1.5rem;
      background: #fff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.1rem;
      padding: 0.1rem;

      .qr-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .qr-tip {
      color: #333;
      font-size: 0.22rem;
      font-weight: bold;
    }
  }

  .qr-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .share-link {
      display: flex;
      align-items: center;
      background: #292A2C;
      border-radius: 0.08rem;
      padding: 0.1rem;
      margin-bottom: 0.15rem;

      .link-select {
        width: 90%;
        min-width: 0;
        background: transparent;
        border: none;
        outline: none;
        color: #999;
        font-size: 0.3rem;
        padding: 0;
        box-sizing: border-box;
        appearance: none;
        -webkit-appearance: none;

        option {
          background: #292A2C;
          color: #999;
        }
      }

      .link-copy {
        color: #DFB372;
        margin-left: 0.1rem;
        cursor: pointer;
        flex-shrink: 0;
      }
    }

    .share-buttons {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;
      gap: 0.3rem;
      padding-right: 0.1rem;

      &::-webkit-scrollbar {
        display: none;
      }

      .share-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        flex-shrink: 0;

        .share-icon-share {
          width: 1.1rem;
          height: 1.1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.08rem;
        }

        .share-icon-img {
          width: 1.1rem;
          height: 1.1rem;
          object-fit: contain;
          margin-bottom: 0.08rem;
        }

        .share-text {
          color: #898989;
          font-size: 0.3rem;
          text-align: center;
          margin-top: 0.1rem;
        }
      }
    }
  }
}

.tutorial-card {
  background: #292a2c;
  border-radius: 0.16rem;
  padding: 0.3rem 0;
  box-sizing: border-box;
  // margin-bottom: 0.24rem;

  .card-title {
    font-size: 0.35rem;
    color: #fff;
    font-weight: 500;
    margin-bottom: 0.2rem;
  }

  .tutorial-tabs {
    display: flex;
    background: #292A2C;
    border-radius: 0.3rem;
    padding: 0.06rem;
    margin-bottom: 0.25rem;

    .tutorial-tab {
      flex: 1;
      text-align: center;
      padding: 0.12rem 0;
      margin: 0 0.1rem;
      font-size: 0.3rem;
      color: #888;
      background: #333436;
      border-radius: 0.25rem;
      cursor: pointer;
      transition: all 0.2s;
      border: 1px solid #646566;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background: #DFB372;
        color: #292A2C;
        font-weight: 500;
      }
    }
  }

  .tutorial-content {
    .tutorial-panel {
      .a-commission-diagram {
        background: #1f1f21;
        border-radius: 0.16rem;
        padding: 0.25rem 0;
        // margin-bottom: 0.25rem;
        position: relative;

        .connect-lines {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
        }

        .agent-card {
          position: relative;
          z-index: 1;
          background: #ede5d8;
          border-radius: 0.16rem;
          padding: 0.15rem;
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;

        }

        .agent-avatar-wrap {
          position: absolute;
          top: -0.35rem;
          left: 50%;
          transform: translateX(-50%);
          width: 0.7rem;
          height: 0.7rem;
          flex-shrink: 0;

          .agent-avatar {
            width: 0.7rem;
            height: 0.7rem;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #d4a86a;
            background: #fff;
          }

          .agent-badge {
            position: absolute;
            right: -0.03rem;
            bottom: -0.03rem;
            width: 0.26rem;
            height: 0.26rem;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.14rem;
            font-weight: bold;
            color: #fff;
            border: 1px solid #fff;

            &.badge-a { background: #d4a86a; }
            &.badge-b { background: #d4a86a; }
            &.badge-c { background: #d4a86a; }
            &.badge-n { background: #4caf50; }
          }
        }

        .agent-a {
          background: #292A2C;
          align-items: center;
          padding: 0.25rem 0.2rem;

          .agent-avatar-wrap {
            position: relative;
            top: auto;
            left: auto;
            transform: none;
            margin-right: 0.2rem;
            width: 1rem;
            height: 1rem;

            .agent-avatar {
              width: 1rem;
              height: 1rem;
            }

            .agent-badge {
              width: 0.36rem;
              height: 0.36rem;
              font-size: 0.2rem;
            }
          }

          .agent-left {
            margin-right: 0.25rem;
          }

          .agent-right {
            flex: 1;

            .calc-line {
              color: #fff;
              font-size: 0.3rem;
              line-height: 1.5;

              .calc-label {
                color: #fff;
              }

              .calc-gold {
                color: #DFB372;
                font-weight: bold;
              }
            }
          }
        }

        .b-level-row,
        .c-level-row {
          display: flex;
          gap: 0.3rem;
          margin-bottom: 0.05rem;

          &.single {
            justify-content: center;

            .agent-card {
              flex: 0 0 48%;
            }
          }

          .agent-card {
            flex: 1;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 0.4rem 0.08rem 0.18rem;
            margin-top: 0.35rem;

            .agent-avatar-wrap {
              margin-right: 0;
              margin-bottom: 0;
            }

            .agent-body {
              .agent-bet {
                color: #333;
                font-size: 0.3rem;
                font-weight: bold;
                margin-bottom: 0.03rem;
              }

              .agent-calc {
                color: #666;
                font-size: 0.3rem;
                line-height: 1.3;

                .calc-gold {
                  color: #DFB372;
                  font-weight: bold;
                }
              }
            }
          }
        }

        .agent-nd {
          background: #c8e6c9;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 0.4rem 0.15rem 0.18rem;
          margin-top: 0.85rem;

          .agent-avatar-wrap {
            margin-right: 0;
            margin-bottom: 0;
          }

          .agent-body {
            .agent-bet {
              color: #333;
              font-size: 0.3rem;
              font-weight: bold;
              margin-bottom: 0.03rem;
            }

            .agent-calc {
              color: #666;
              font-size: 0.26rem;
            }
          }
        }
      }

      .commission-detail {
        background: #292A2C;
        border-radius: 0.12rem;
        padding: 0.2rem 0.25rem;

        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.12rem 0;
          border-bottom: 1px solid #3B3C3D;

          &:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }

          &:first-child {
            padding-top: 0;
          }

          .detail-label {
            color: #888;
            font-size: 0.22rem;
          }

          .detail-value {
            color: #fff;
            font-size: 0.24rem;

            &.gold {
              color: #DFB372;
              font-weight: bold;
            }

            &.big {
              font-size: 0.3rem;
            }
          }
        }
      }
    }
  }
}

.bottom-note-card {
  background: #333436;
  border-radius: 0.16rem;
  padding: 0.3rem;
  box-sizing: border-box;
  margin-bottom: 2rem;

  .note-title {
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    color: #fff;
    font-weight: 500;
    margin-bottom: 0.15rem;
    padding-bottom: 0.15rem;
    border-bottom: 1px solid #444;

    .van-icon {
      margin-right: 0.1rem;
    }
  }

  .note-content {
    color: #f2f3f5;
    font-size: 0.22rem;
    line-height: 1.6;
    margin-bottom: 0.2rem;

    p {
      margin: 0;
    }
  }

  .example-section {
    background: #292A2C;
    border-radius: 0.1rem;
    padding: 0.2rem 0.25rem;

    .example-title {
      color: #DFB372;
      font-size: 0.22rem;
      font-weight: 500;
      margin-bottom: 0.12rem;
    }

    .example-content {
      color: #888;
      font-size: 0.2rem;
      line-height: 1.8;

      p {
        margin: 0;
      }
    }
  }
}

.bottom-space {
  height: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/Share.vue